import Navbar from './components/Navbar';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />

        <MediaSection />

        <FAQSection />

        <CarouselSection />

        <AboutSection />

        <CardsSection />

        <FeaturesSection />

        <RankingSection />

        <ContactSection />

        <TopicsSection />

        <IndexSection />

        <AppSection />

        <CommentsSection />

        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}